import React from "react";
import {Edit as EditIcon} from "@material-ui/icons";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import MenuHeader from "../../components/MenuHeader";
import MenuBackButton from "../../components/MenuBackButton";
import LinkMenuItem from "../../components/LinkMenuItem";

export default class MarkerSettingsMenu extends React.Component {
  render() {
    const {match} = this.props;
    const {facilityId} = this.props.location.query;
    return (
      <React.Fragment>
        <MenuBackButton to={"/facilities"} />
        <List>
          <MenuHeader>Marker Settings</MenuHeader>
          <LinkMenuItem
            to={`/marker-types?facilityId=${facilityId}`}
            selected={match.url.startsWith("/marker-types")}
            primary={<p className="menuItemText">Marker Types</p>}
            secondary="Create icons to represent things like 'Fire Hydrants' or 'Gas Cuttofs'"
            rightIcon={<EditIcon />}
          />
          <Divider />
          <LinkMenuItem
            to={`/marker-categories?facilityId=${facilityId}`}
            selected={match.url.startsWith("/marker-categories")}
            primary={<p className="menuItemText">Marker Categories</p>}
            secondary="Group your icons into meaningful categories like 'Plumbing' or 'WiFi'"
            rightIcon={<EditIcon />}
          />
        </List>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/Menus/MarkerSettingsMenu/index.jsx